import {phaseStatus} from '~HIOR/constants'

export default {
  computed: {
    $phaseStatus() {
      return [
        {
          label: 'Nog niet beschikbaar',
          value: phaseStatus.STATUS_UNCOMPLETED,
          color: 'uncompleted'
        },
        {
          label: 'Actief',
          value: phaseStatus.STATUS_ACTIVE,
          color: 'active'
        },
        {
          label: 'Afgerond',
          value: phaseStatus.STATUS_COMPLETED,
          color: 'completed'
        },
        {
          label: 'Overgeslagen',
          value: phaseStatus.STATUS_SKIPPED,
          color: 'skipped'
        },
      ]
    }
  },
  methods: {
    $phaseStatusLabel(status) {
      const phaseStatus = this.$phaseStatus.find((phaseStatus) => {
        if (phaseStatus.value === parseInt(status)) {
          return phaseStatus
        }
      })

      return phaseStatus ? phaseStatus.label : null
    },
    $phaseStatusColor(status) {
      const phaseStatus = this.$phaseStatus.find((phaseStatus) => {
        if (phaseStatus.value === parseInt(status)) {
          return phaseStatus
        }
      })

      return phaseStatus ? phaseStatus.color : null
    }
  }
}

